<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分销商积分有效期（月）" prop="distributorEffectiveTime">
        <a-input
          oninput="value=value.replace(/[^\d]/g,'')"
          v-model="form.distributorEffectiveTime"
          placeholder="请输入"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="验收员有效期(月)" prop="distributorEffectiveTime">
        <a-input
          oninput="value=value.replace(/[^\d]/g,'')"
          v-model="form.distributorEffectiveTime"
          placeholder="请输入"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="水工积分有效期(月)" prop="distributorEffectiveTime">
        <a-input
          oninput="value=value.replace(/[^\d]/g,'')"
          v-model="form.distributorEffectiveTime"
          placeholder="请输入"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="150" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, putObj } from '@/api/pressure/pointsRule'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        distributorEffectiveTime: undefined,
        inspectionEffectiveTime: undefined,
        tenantId: undefined,
        waterWorkerEffectiveTime: undefined,
        remark: undefined,
      },
      open: false,
      rules: {
        waterWorkerEffectiveTime: [{ required: true, message: '请输入水工积分有效期', trigger: 'blur' }],
        inspectionEffectiveTime: [{ required: true, message: '验收员有效期', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入分销商积分有效期', trigger: 'blur' }],
        distributorEffectiveTime: [{ required: true, message: '请输入分销商积分有效期', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
       this.onClose()
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        devCode: undefined,
        devName: undefined,
        tenantFirmId: undefined,
        remark: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加设备'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改设备'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } 
        } else {
          return false
        }
      })
    },
  },
}
</script>
